import React, { FunctionComponent, ReactNode } from "react";
import logo from "../assets/stumbled.png"
import {
    Route,
    BrowserRouter as Router,
    Switch,
    RouteComponentProps,
} from "react-router-dom";
import Auth from "@aws-amplify/auth";
import Credentials from "../components/register/person/Credentials";
import { MemberRegisterConfirmation } from "../components/register/person/MemberRegisterConfirmation";
import { Color, Path, Storage } from "../env";
import { Storage as S3 } from "aws-amplify";
import { uploadToProfilesBucket } from "../client/s3-profiles";
import RegisterShop from "../components/register/shop/RegisterShop";
import {
    RegisterShop as RegisterShopAPI,
    PutShopName,
    SetShopAddress as SetShopAddressAPI,
    GetProducts,
    GetDelivery,
    GetOrders,
    GetShopSummary,
    RegisterAccount as RegisterAccountAPI,
    UpdateOrderStatus,
    SetShopContactDetails as SetShopContactDetailsAPI,
    PaymentsOptOut,
    GetCategories,
    GetPaymentDetails,
    UpdateCustomPaymentDetails,
    ToggleProduct,
    GetAttachedShops,
    PaymentsOptIn,
    UpdateZettleIntegration,
    GetShopCustomers,
    DeliveryOptIn,
    DeliveryOptOut,
    AddAdditionalShop as AddAdditionalShopAPI,
    GetIntegrations,
    ToggleActiveShop,
    GetShopContactDetails,
    AssignUserToShopRequest,
    ReferShop as ReferShopAPI,
    ConfirmShopCreation,
    AssignUserToShopConfirmation,
    GetShopReferralsInfo,
    SetSocialMedia as SetSocialMediaAPI,
    GetZettleProducts,
    SyncProducts,
    GetNearbyShops,
    GetReferredShop,
    UpdateReferredShop,
    SetAvailability,
    GetAvailability,
    GetBookings,
    AddBooking,
    UpdateBooking,
    DeleteBooking,
    ToggleBooking
} from "../client/core";
import ShopName from "../components/register/shop/ShopName";
import Login from "../components/register/person/Login";
import SetShopAddress from "../components/register/shop/SetShopAddress";
import ListProducts from "../components/products/ListProducts";
import Navbar, { Sidebar } from "../components/menu/Navbar";
import { Col, Container, Row } from "react-bootstrap";
import ShopDashboard from "../components/dashboard/ShopDashboard";
import Delivery from "../components/delivery/Delivery";
import ListOrders from "../components/orders/ListOrders";
import ShopContactDetails from "../components/register/shop/SetContactDetails";
import RegisterAccount from "../components/register/shop/RegisterAccount";
import Integrations from "../components/integrations/Integrations";
import Account from "../components/payments/Account";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import Zettle from "../components/integrations/Zettle";
import ResetPassword from "../components/register/person/ResetPassword";
import Customers from "../components/customers/Customers";
import AddAdditionalShop from "../components/register/shop/AddAdditionalShop";
import Referral from "../components/referral/Referral";
import ReferShop from "../components/referral/ReferShop";
import ShopReferralConfirmation from "../components/referral/ShopReferralConfirmation";
import AddUserToShop from "../components/register/person/AddUserToShop";
import ReferralDashboard from "../components/referral/ReferralDashboard";
import SetSocialMedia from "../components/register/shop/SetSocialMedia";
import ZettleDashboard from "../components/integrations/ZettleDashboard";
import UploadMobileImage from "../components/referral/UploadMobileImage";
import { Button, variant } from "../components/form/Button";
import { FaHeart } from "react-icons/fa";
import OverlayCurtain from "../components/animation/OverlayCurtain";
import ShopReferralAmendment from "../components/referral/ShopReferralAmendment";
import BulkMediaUpload from "../components/account/BulkMediaUpload";
import Collections from "../components/collections";
import Bookings from "../components/bookings";


export const Routes: FunctionComponent<{}> = () => {
    const dispatch = useDispatch()
    return (
        <Router>
            <Switch>
                <Route
                    exact
                    path={Path.Home}
                    render={(props) =>
                        Screen(
                            <ShopDashboard
                                {...props}
                                auth={Auth}
                                getShopAPI={new GetShopSummary()}
                                toggleActiveShop={new ToggleActiveShop()}
                                registerShopAPI={new RegisterAccountAPI()}
                            />,
                            props,
                            dispatch
                        )
                    }
                />
                <Route
                    exact
                    path={Path.ShopDashboard}
                    render={(props) =>
                        Screen(
                            <ShopDashboard
                                {...props}
                                auth={Auth}
                                getShopAPI={new GetShopSummary()}
                                toggleActiveShop={new ToggleActiveShop()}
                                registerShopAPI={new RegisterAccountAPI()}
                            />,
                            props,
                            dispatch
                        )
                    }
                />
                <Route
                    exact
                    path={Path.Welcome}
                    render={(props) =>
                        <OverlayCurtain message="🎉 Congratulations! Welcome to Stumbled!">
                            {Screen(
                                <ShopDashboard
                                    {...props}
                                    auth={Auth}
                                    getShopAPI={new GetShopSummary()}
                                    toggleActiveShop={new ToggleActiveShop()}
                                    registerShopAPI={new RegisterAccountAPI()}
                                />,
                                props,
                                dispatch
                            )}
                        </OverlayCurtain>
                    }
                />
                <Route
                    exact
                    path={Path.RegisterMember}
                    render={(props) =>
                        RegistrationScreen(<Credentials {...props} auth={Auth} />, "Lets get started", "Sign up and start your shop for free! Once you create your account, you can log in anytime to set up your shop and add your products — no hidden fees, just start selling.", props)
                    }
                />
                <Route
                    exact
                    path={Path.RegisterMemberConfirmation}
                    render={(props) =>
                        RegistrationScreen(<MemberRegisterConfirmation {...props} />, "We sent you a verification email", "Thanks for registering! We’ve sent you a verification email — please click the link to verify your account. Once verified, you’ll be ready to log in.", props)
                    }
                />
                <Route
                    exact
                    path={Path.RegisterShop}
                    render={(props) =>
                        RegistrationScreen(
                            <RegisterShop
                                getShopContactDetails={new GetShopContactDetails().GetShopContactDetails}
                                getShop={new GetShopSummary().GetShopSummary}
                                auth={Auth}
                                registerShop={new RegisterShopAPI().RegisterShop}
                                assignUserToShopRequest={new AssignUserToShopRequest().AssignUserToShopRequest}
                                {...props}
                            />,
                            "Let's begin",
                            "Time to get this ball rolling — register your shop and start reaching customers!",
                            props
                        )
                    }
                />
                <Route
                    exact
                    path={Path.RegisterShopName}
                    render={(props) =>
                        RegistrationScreen(
                            <ShopName
                                auth={Auth}
                                coreAPI={new PutShopName()}
                                {...props}
                            />,
                            "Shop name",
                            "Your Shop name will be how the customers identify your shop on the platform.",
                            props
                        )
                    }
                />
                <Route
                    exact
                    path={Path.RegisterShopContact}
                    render={(props) =>
                        RegistrationScreen(
                            <ShopContactDetails
                                auth={Auth}
                                coreAPI={new SetShopContactDetailsAPI()}
                                {...props}
                            />,
                            "Contact Info",
                            "Keep on top of things! Enter your email and phone for updates on orders and other shop essentials — zero spam.",
                            props
                        )
                    }
                />
                <Route
                    exact
                    path={Path.RegisterShopSocials}
                    render={(props) =>
                        RegistrationScreen(
                            <SetSocialMedia
                                {...props}
                                auth={Auth}
                                setSocialMediaAPI={new SetSocialMediaAPI()}
                            />,
                            "It's all about the socials",
                            "Show off your social side! Linking your social media helps customers connect with you and your brand.",
                            props
                        )
                    }
                />
                <Route
                    exact
                    path={Path.RegisterShopAccount}
                    render={(props) =>
                        RegistrationScreen(
                            <RegisterAccount
                                auth={Auth}
                                registerAccountAPI={new RegisterAccountAPI()}
                                paymentOptOutAPI={new PaymentsOptOut()}
                                {...props}
                            />,
                            "Online Payments",
                            "Take payments your way — online through Stripe, safely handled with no fees for you, or offline using your own method with customer instructions through the platform.",
                            props
                        )
                    }
                />
                <Route
                    exact
                    path={Path.RegisterShopAddress}
                    render={(props) =>
                        RegistrationScreen(
                            <SetShopAddress
                                auth={Auth}
                                coreAPI={new SetShopAddressAPI()}
                                {...props}
                            />,
                            "Location, location, location",
                            "Your shop location helps customers nearby discover you — whether for collection or delivery — and keeps orders within reach.",
                            props
                        )
                    }
                />
                <Route
                    exact
                    path={Path.Products}
                    render={(props) =>
                        Screen(
                            <ListProducts
                                getCategoriesAPI={new GetCategories()}
                                toggleProductAPI={new ToggleProduct()}
                                auth={Auth}
                                coreAPI={new GetProducts()}
                                {...props}
                            />,
                            props,
                            dispatch
                        )
                    }
                />
                <Route
                    exact
                    path={Path.Customers}
                    render={(props) =>
                        Screen(
                            <Customers
                                auth={Auth}
                                getCustomersAPI={new GetShopCustomers()}
                                {...props}
                            />,
                            props,
                            dispatch
                        )
                    }
                />
                <Route
                    exact
                    path={Path.Collections}
                    render={(props) =>
                        Screen(
                            <Collections
                                auth={Auth}
                                shopId={localStorage.getItem(Storage.ShopID) || ""}
                                onGetAvailability={new GetAvailability().GetAvailability}
                                onSave={new SetAvailability().SetAvailability}
                                {...props}
                            />,
                            props,
                            dispatch
                        )
                    }
                />
                <Route
                    exact
                    path={Path.Bookings}
                    render={(props) =>
                        Screen(
                            <Bookings
                                {...props}
                                getBookings={(input) => new GetBookings().GetBookings(input)}
                                addBooking={(input) => new AddBooking().AddBooking(input)}
                                updateBooking={(input) => new UpdateBooking().UpdateBooking(input)}
                                deleteBooking={(input) => new DeleteBooking().DeleteBooking(input)}
                                toggleBooking={(input) => new ToggleBooking().ToggleBooking(input)}
                                currentSession={() => Auth.currentSession()}
                                imageStore={S3}
                            />,
                            props,
                            dispatch
                        )
                    }
                />
                <Route
                    exact
                    path={Path.Delivery}
                    render={(props) =>
                        Screen(
                            <Delivery
                                auth={Auth}
                                getDeliveryAPI={new GetDelivery()}
                                optInDeliveryAPI={new DeliveryOptIn()}
                                optOutDeliveryAPI={new DeliveryOptOut()}
                                {...props}
                            />,
                            props,
                            dispatch
                        )
                    }
                />
                <Route
                    exact
                    path={Path.AddShop}
                    render={(props) =>
                        Screen(
                            <AddAdditionalShop
                                auth={Auth}
                                coreAPI={new AddAdditionalShopAPI()}
                                {...props}
                            />,
                            props,
                            dispatch
                        )
                    }
                />
                <Route
                    exact
                    path={Path.Orders}
                    render={(props) =>
                        Screen(
                            <ListOrders
                                auth={Auth}
                                coreAPI={new GetOrders()}
                                updateOrderStatusAPI={new UpdateOrderStatus()}
                                {...props}
                            />,
                            props,
                            dispatch
                        )
                    }
                />
                <Route
                    exact
                    path={Path.Integrations}
                    render={(props) =>
                        Screen(
                            <Integrations
                                auth={Auth}
                                getIntegrationsApi={new GetIntegrations()}
                                registerStripeAccountApi={new RegisterAccountAPI()}
                                {...props}
                            />,
                            props,
                            dispatch
                        )
                    }
                />
                <Route
                    exact
                    path={Path.IntegrationsZettle}
                    render={(props) => (
                        <Zettle
                            updateZettleIntegrationAPI={new UpdateZettleIntegration()}
                            auth={Auth}
                            {...props}
                        />
                    )}
                />
                <Route
                    exact
                    path={Path.Payments}
                    render={(props) =>
                        Screen(
                            <Account
                                auth={Auth}
                                registerAccountAPI={new RegisterAccountAPI()}
                                paymentOptOutAPI={new PaymentsOptOut()}
                                getPaymentDetailsAPI={new GetPaymentDetails()}
                                updateCustomPaymentDetailsAPI={new UpdateCustomPaymentDetails()}
                                paymentOptInAPI={new PaymentsOptIn()}
                                {...props}
                            />,
                            props,
                            dispatch
                        )
                    }
                />
                <Route
                    exact
                    path={Path.Zettle}
                    render={(props) =>
                        Screen(
                            <ZettleDashboard
                                getStumbledProducts={new GetProducts()}
                                getZettleProducts={new GetZettleProducts()}
                                syncProducts={new SyncProducts()}
                                auth={Auth}
                                {...props}
                            />,
                            props,
                            dispatch
                        )
                    }
                />
                <Route
                    exact
                    path={Path.Referral}
                    render={(props) =>
                        <Referral {...props} />
                    }
                />
                <Route
                    exact
                    path={Path.Referrals}
                    render={(props) =>
                        Screen(
                            <ReferralDashboard
                                RegisterAccount={new RegisterAccountAPI().RegisterAccount}
                                GetShopReferralInfo={new GetShopReferralsInfo().GetShopReferralInfo}
                                auth={Auth}
                                {...props} />,
                            props,
                            dispatch
                        )
                    }
                />
                <Route
                    exact
                    path={Path.Login}
                    render={(props) =>
                        <Login auth={Auth} {...props} />
                    }
                />
                <Route
                    exact
                    path={Path.ResetPassword}
                    render={(props) =>
                        <div style={{ marginTop: "10vh", marginBottom: "10vh" }}>
                            <ResetPassword auth={Auth} {...props} />
                        </div>
                    }
                />
                <Route
                    exact
                    path={Path.ReferShop}
                    render={(props) =>
                        RegistrationScreen(
                            <ReferShop googleApiKey={process.env.REACT_APP_CORE_GOOGLE_PLACES_KEY!} imageStore={S3} referShopAPI={new ReferShopAPI()} {...props} />,
                            "Join the Local Revival",
                            "Stumbled is a free, cooperative platform for local independents — built to help shops get online easily and grow together. We take care of the tech so you can focus on your craft, your customers, and your community. By joining, you become part of a network of shops working together to bring people back to local shopping. All we ask is that you recommend Stumbled to other independents, helping us strengthen the community and keep local thriving.",
                            props,
                        )
                    }
                />
                <Route
                    exact
                    path={Path.MediaUpload}
                    render={(props) =>
                        RegistrationScreen(
                            <BulkMediaUpload onFileUpload={uploadToProfilesBucket} {...props} />,
                            "Share Your Story — We’ll Help You Shine",
                            "Upload your photos, videos, and words, and we’ll turn them into posts that celebrate your shop and the people behind it. At Stumbled, we believe every local shop has a story worth sharing — we’re just here to help it reach more hearts in your community.",
                            props,
                        )
                    }
                />
                <Route
                    exact
                    path={Path.AddMobileImage}
                    render={(props) =>
                        <div style={{ marginTop: "10vh", marginBottom: "10vh" }}>
                            <UploadMobileImage googleApiKey={process.env.REACT_APP_CORE_GOOGLE_PLACES_KEY!} imageStore={S3} getShops={new GetNearbyShops().GetNearbyShops} {...props} />
                        </div>
                    }
                />
                <Route
                    exact
                    path={Path.ConfirmShopCreation}
                    render={(props) =>
                        RegistrationScreen(
                            <ShopReferralConfirmation confirmShopCreation={new ConfirmShopCreation().ConfirmShopCreation} {...props} />,
                            "Welcome to the community",
                            "Your shop is what gives the street its character. We’re here to help more people discover you, shop with you, and keep your community thriving — without the admin weighing you down.",
                            props,
                        )
                    }
                />
                <Route
                    exact
                    path={Path.AmendShopCreation}
                    render={(props) =>
                        RegistrationScreen(
                            <ShopReferralAmendment
                                getReferredShop={new GetReferredShop().GetReferredShop}
                                updateReferredShop={new UpdateReferredShop().UpdateReferredShop}
                                onImageUpload={S3.put}
                                {...props}
                            />,
                            "A quick amendment",
                            "Your shop is what gives the street its character. We're here to help more people discover you, shop with you, and keep your community thriving — without the admin weighing you down.",
                            props,
                        )
                    }
                />
                <Route
                    exact
                    path={Path.AssignUserConfirmation}
                    render={(props) =>
                        RegistrationScreen(
                            <AddUserToShop assignUserToShopConfirmation={new AssignUserToShopConfirmation().AssignUserToShopConfirmation} {...props} />,
                            "Linking user",
                            "All set! The new user has joined the shop and can now take the reins in the dashboard.",
                            props
                        )
                    }
                />
            </Switch>
        </Router>
    );
}

function Screen(component: ReactNode, props: RouteComponentProps, dispatch: Dispatch) {
    return (
        <div>
            <Navbar shopsDispatch={dispatch} getAttachedShopsAPI={new GetAttachedShops()} auth={Auth} {...props} />
            <Container fluid style={{ maxWidth: "100%", height: "100vh" }}>
                <Row style={{ height: "100vh" }}>
                    <Col md={3} lg={2} className={"d-none d-md-block"} style={{ background: Color.LightGrey, padding: "4rem 0 0 0" }}>
                        <Row style={{ position: "fixed", width: "100%", margin: 0, padding: 0 }}>
                            <Col md={3} lg={2} style={{ padding: 0 }} className={"d-none d-md-block"}>
                                <Sidebar {...props} auth={Auth} getIntegrationsApi={new GetIntegrations()} />
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12} md={9} lg={10} style={{ background: Color.White, paddingTop: "4rem", paddingLeft: "4vw", paddingRight: "4vw", marginTop: "2rem", zIndex: 2 }}>
                        {component}
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

function RegistrationScreen(mainComponent: ReactNode, title: string, description: string, props: RouteComponentProps) {
    return (
        <Row className="g-0 h-100">
            {/* Mobile-only column */}
            <Col
                xs={12}
                className="d-block d-md-none"
                style={{
                    background: Color.Primary,
                    padding: "1rem" // maybe lighter padding on mobile?
                }}
            >
                <div style={{ marginTop: "20px", color: Color.White, textAlign: "center" }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "1rem", gap: "10px" }}>
                        <span
                            style={{
                                background: Color.White,
                                width: "30px",
                                height: "30px",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                overflow: "hidden",
                            }}
                        >
                            <img
                                src={logo}
                                alt="Logo"
                                style={{
                                    width: "90%",   // slightly smaller than container to fit nicely
                                    height: "90%",
                                    objectFit: "contain",
                                }}
                            />
                        </span>
                        <h5 style={{ color: Color.White, margin: 0 }}>Stumbled</h5>
                    </div>
                    <h5>{title}</h5>
                    <p>{description}</p>
                </div>
            </Col>

            {/* Desktop-only column */}
            <Col
                md={4}
                className="d-none d-md-flex flex-column"
                style={{
                    background: Color.Primary,
                    minHeight: "100vh",
                    padding: "60px",
                    boxSizing: "border-box"
                }}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <span
                        style={{
                            background: Color.White,
                            width: "35px",
                            height: "35px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            overflow: "hidden",
                        }}
                    >
                        <img
                            src={logo}
                            alt="Logo"
                            style={{
                                width: "90%",   // slightly smaller than container to fit nicely
                                height: "90%",
                                objectFit: "contain",
                            }}
                        />
                    </span>
                    <h5 style={{ color: Color.White, margin: 0 }}>Stumbled</h5>
                </div>
                <div style={{ marginTop: "40px", color: Color.White }}>
                    <h1>{title}</h1>
                    <p style={{ fontSize: "1.2rem", marginTop: "1rem" }}>{description}</p>
                </div>
                {/* Footer pushed to bottom */}
                <div style={{ color: Color.White, marginTop: "auto" }} className="footer">
                    <p>
                        Powered by <span style={{ fontWeight: "bolder" }}>Local Independents</span> <FaHeart />
                    </p>
                    <p><a>Privacy</a></p>
                    <p><a>Terms</a></p>
                    <hr />
                    <p>Want us to help get you set-up?</p>
                    <Button
                        style={{ border: `1px solid ${Color.White}` }}
                        buttonvariant={variant.Primary}
                        name="Book a meeting"
                        onClick={() => window.open("https://calendly.com/stumbled", "_blank")}
                    />
                </div>
            </Col>

            {/* Mobile content column */}
            <Col className="d-block d-md-none" style={{ padding: "1rem" }}>
                {mainComponent}
            </Col>

            {/* Desktop content column */}
            <Col
                className="d-none d-md-flex flex-column"
                style={{
                    height: "100vh",          // full viewport height
                    padding: "80px 40px 40px 80px",
                    boxSizing: "border-box",
                    overflowY: "auto",        // make it scrollable
                }}
            >
                <div style={{ maxWidth: "450px" }}>
                    {mainComponent}
                </div>
            </Col>

            <Col
                xs={12}
                className="d-block d-md-none"
                style={{ padding: "20px", background: Color.LightGrey }}
            >
                <div style={{ marginTop: "auto" }} className="footer">
                    <p>
                        Powered by <span style={{ fontWeight: "bolder" }}>Local Independents</span> <FaHeart />
                    </p>
                    <p><a>Privacy</a></p>
                    <p><a>Terms</a></p>
                    <hr />
                    <p>Want us to help get you set-up?</p>
                    <Button
                        style={{ border: "1px solid #000", color: "#000" }}
                        buttonvariant={variant.NoFill}
                        name="Book a meeting"
                        onClick={() => { }}
                    />
                </div>
            </Col>
        </Row>
    );
}